import { TaskCategoryProgress } from "@/interfaces/progress_types";
import { getColorClass } from "../../../_Shared/getColorClass";
import { AssignedUserBubble } from "../../../_Shared/AssignedUserBubble";

type ProjectProgressBarHoverProps = {
    mousePosition: { x: number; y: number }
    category: string
    color: string
    category_progress: TaskCategoryProgress
}
export function ProjectProgressBarHover({ mousePosition, category, color, category_progress }: ProjectProgressBarHoverProps) {
    return (
        <div
            className={`bg-white dark:bg-stone-800 border ${getColorClass(color, 500, "border")} rounded-md shadow-md p-2 text-sm pointer-events-none z-50 fixed`}
            style={{
                left: `${mousePosition.x + 15}px`,
                top: `${mousePosition.y - 40}px`,
            }}
        >
            <div className="font-semibold">{category}</div>
            <div className="flex flex-col">
                <div>Completion: {category_progress.percent_complete.toFixed(1)}%</div>
                <div>Tasks Completed: {category_progress.tasks_completed}/{category_progress.tasks_total}</div>

                <div className="mt-2">
                    <span className="font-semibold">Assigned Users:</span>
                    <div className="flex flex-wrap gap-2 max-w-[10rem]">
                        {category_progress.assigned_users.map((user) => (
                            <AssignedUserBubble key={user} user={user} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
